import { Provider } from "react-redux";
import { QueryClientProvider } from "@tanstack/react-query";
import { Suspense, useEffect } from "react";
import { RouterProvider } from "react-router-dom";

import { GuideTourProvider } from "../packages/guide-tour/src";
import { useAuth } from "./hooks/useAuth";
import { createPurchaseQueryClient } from "./lib/queryClient";
import { store } from "./redux/store";
import { router } from "./router";

export const queryClient = createPurchaseQueryClient();

function AuthBootstrap() {
  const { initialize } = useAuth();

  useEffect(() => {
    void initialize();
  }, []);

  return null;
}

export default function App() {
  return (
    <Provider store={store}>
      <GuideTourProvider>
        <QueryClientProvider client={queryClient}>
          <AuthBootstrap />
          <Suspense fallback={<div>Loading...</div>}>
            <RouterProvider router={router} />
          </Suspense>
        </QueryClientProvider>
      </GuideTourProvider>
    </Provider>
  );
}
